/* eslint-disable @typescript-eslint/no-explicit-any */
import Layout from '../../../../common/components/layout/Layout';
import Header from '../../../../common/components/layout/Header';

import PaymentLabels from '../../../../common/components/modules/sports/PaymentLabelsLeft';
import LayoutInside from '../../../../common/components/layout/LayoutInside';
import { useHistory, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGameById, gameCancelSubcription } from '../../../../modules/sport/actions/reducerGame';
import Loading from '../../../../common/loading/Loading';
import { IGame } from '../../../../modules/sport/interfaces/game';
import { format } from 'date-fns';
import ChartDonught from '../../../../common/components/chart/Doughnut';
import Team from '../../../../common/components/sections/Team';
import CircleComponent from '../../../../common/components/sections/CircleComponent';
import Msj from '../../../../common/components/sections/Msj';
import Copy from '../../../../common/components/sections/Copy';
import MsjSuccess from '../../../../common/components/sections/MsjSuccess';
import { attributesBySport } from '../../../../common/data/attributes';
import Image from '../../../../common/Image';
import CoverImg from '../../../../common/components/images/fondo.png';
import Clock from '../../../../common/components/sections/clock';
import { ghostGame } from '../../../../common/data/ghost';
import { formatPrice } from '../../../../utils';
import { useAuth } from '../../../../context/auth-context';
import LinkChat from '../../../../common/components/sections/LinkChat';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Inscription = (): JSX.Element => {
    const auth = useAuth();

    const attribute = attributesBySport('integrate');
    const dispatch = useDispatch();
    const router = useHistory();
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const sport = pathname.length > 0 ? pathname[1] : 'futbol';
    const query = useQuery();
    const [title, setTitle] = useState<string>();
    const gameId = query.get('gameId');
    const selectGame = (state: any) => state.game;
    const game = useSelector(selectGame);
    const [detGame, setDetGame] = useState<IGame | null>(null);
    const [friends, setFriends] = useState({ current: 0 });
    const [msj, setMsj] = useState('');
    const [cancelSuscription, setCancelSuscription] = useState<string>('inactive');
    const [statusCancel, setStatusCancel] = useState(false);
    const [dateMatch, setDateMatch] = useState({ start: '', end: '', date: '', format: '', club: '' });
    const day = query.get('day');
    const region = query.get('region');
    const commune = query.get('commune');
    const [timeGame, setTimeGame] = useState(false);
    const mydate = new Date();
    const role = auth?.user?.role || 'PLAYER';
    const linkBase = process.env.REACT_APP_URL_DASHBOARD;
    const [linkDashboard, setLinkDashboard] = useState<string>();

    const [linkChat, setLinkChat] = useState<string>();

    const pathnameGames = `/${sport}/integrar/partidos/filter`;

    const pathnameAll = window.location.pathname + useLocation().search;

    const [breads, setBreads] = useState([
        {
            key: 'integrar',
            name: 'Integrar | Buscar',
            url: `/integrar`,
            add: true,
        },
        {
            key: 'partidos',
            name: 'Partidos',
            url: pathnameGames,
            add: false,
        },
        {
            key: 'unirse',
            name: 'Unirse',
            url: pathnameAll,
            add: false,
        },
    ]);

    useEffect(() => {
        setDetGame(null);
        dispatch(fetchGameById(gameId, auth.isLoggedIn));
    }, [gameId]);

    useEffect(() => {
        if (day || region || commune) {
            const pathQuery = `?region=${region}&commune=${commune}&day=${day}`;

            const pathnameGames = `/${sport}/integrar/partidos/filter${(day || region || commune) && pathQuery}`;

            setBreads([
                {
                    key: 'integrar',
                    name: 'Integrar | Buscar',
                    url: `/integrar`,
                    add: true,
                },
                {
                    key: 'partidos',
                    name: 'Partidos',
                    url: pathnameGames,
                    add: false,
                },
                {
                    key: 'unirse',
                    name: 'Unirse',
                    url: pathnameAll,
                    add: false,
                },
            ]);
        }
    }, [day, region, commune]);

    useEffect(() => {
        if (game) {
            if (game.data?.statusCode === 'GAME_CANCEL_SUBSCRIPTION_SUCCESSFULLY') {
                setStatusCancel(true);
            } else if (game.data) {
                setStatusCancel(false);
                const newGame = ghostGame(game.data?.data, sport);
                setDetGame(newGame);
            }
        }
    }, [game]);

    useEffect(() => {
        if (detGame && detGame.reservation && detGame.reservation.start) {
            //console.log(detGame.alreadyPaid);
            setFriends({ ...friends, current: detGame.guestsCount });
            setLinkChat(detGame.linkChat);
            /*console.log(
                process.env.REACT_APP_URL_FILE,
                process.env.REACT_APP_URL_DASHBOARD,
                ' aqui ',
                `${linkBase}game/${detGame.id}`,
            );*/
            setLinkDashboard(`${linkBase}game/${detGame.id}`);
            //console.log({ detGame });
            const regionId = detGame.field?.club?.regionId;
            const countyId = detGame.field?.club?.countyId;

            if (!(day || region || commune)) {
                const pathnameGames = `/${sport}/integrar/partidos/filter?region=${regionId}&commune=${countyId}`;

                setBreads([
                    {
                        key: 'integrar',
                        name: 'Integrar | Buscar',
                        url: `/integrar`,
                        add: true,
                    },
                    {
                        key: 'partidos',
                        name: 'Partidos',
                        url: pathnameGames,
                        add: false,
                    },
                    {
                        key: 'unirse',
                        name: 'Unirse',
                        url: pathnameAll,
                        add: false,
                    },
                ]);
            }

            setDateMatch({
                start: format(new Date(detGame.reservation?.start), "H':'mm"),
                date: format(new Date(detGame.reservation.start), "dd'-'MM'-'Y"),
                end: format(new Date(detGame.reservation.end), "H':'mm"),
                format: detGame.field.format?.name || '',
                club: detGame.field.club?.name || '',
            });
            const time: number = Date.parse(detGame.reservation?.start) - Date.parse(mydate.toString());
            if (time < 0) {
                setTimeGame(true);
            } else {
                setTimeGame(false);
            }
        }
    }, [detGame]);

    useEffect(() => {
        if (dateMatch) {
            setTitle(`${dateMatch.club}`);
        }
    }, [dateMatch]);

    const handlerNext = () => {
        if (detGame) {
            const path = `/${sport}/integrar/unirse/confirmar/filter`;
            const search = `?gameId=${detGame.id}&guests=${friends.current}`;
            router.push({
                pathname: path,
                search: search,
            });
        }
    };

    const handlerDeduct = () => {
        setMsj('');
        /*console.log(
            'friends.current:',
            friends.current,
            'detGame.alreadyPaid:',
            detGame.alreadyPaid,
            ' detGame.guestsCount:',
            detGame.guestsCount,
            ' detGame.paidPlayer: ',
            detGame.paidPlayer,
            friends.current <= detGame.paidPlayer ? 'true' : 'false',
        );*/
        if (friends.current > 0) {
            if (detGame.alreadyPaid && friends.current <= detGame.guestsCount) {
                //  console.log('aqui NO resto*******');
            } else {
                if (friends.current <= detGame.paidPlayer - 1) {
                    //       console.log('aqui NO resto 2*******');
                } else {
                    //                    console.log('aqui resto*******');
                    setFriends({ ...friends, current: friends.current - 1 });
                }
            }
        }
    };

    const handlerAdd = () => {
        setMsj('');
        const currentReal = friends && friends.current - detGame.guestsCount;

        if (detGame && detGame.alreadyJoined && detGame.alreadyJoined === true) {
            if (detGame && detGame.available && currentReal < detGame.available) {
                setFriends({ ...friends, current: friends.current + 1 });
            } else {
                if (friends.current + 1 < detGame.maxCapacity) {
                    setFriends({ ...friends, current: friends.current + 1 });
                } else {
                    setMsj(
                        `La disponibilidad maxima para agregar amigos es: ${detGame.available ? detGame.available : 0}`,
                    );
                }
            }
        } else {
            if (detGame && detGame.available && currentReal < detGame.available - 1) {
                setFriends({ ...friends, current: friends.current + 1 });
            } else {
                setMsj(
                    `La disponibilidad maxima para agregar amigos es: ${detGame.available ? detGame.available - 1 : 0}`,
                );
            }
        }
    };

    const handleCancel = (value) => {
        setCancelSuscription(value);
    };

    const handleCancelSubcription = () => {
        dispatch(gameCancelSubcription(gameId));
    };

    const subTitle = '';

    return (
        <Layout navProps={{ title: 'Inscripción | Supermatch', description: 'Inscripción Supermatch' }}>
            <>
                <Header />
                <LayoutInside attribute={attribute} title={title} subTitle={subTitle} breads={breads}>
                    {game.isLoading ? (
                        <Loading />
                    ) : detGame && !statusCancel ? (
                        <>
                            <Msj
                                alreadyJoined={detGame.alreadyJoined ? 'ready' : 'notReady'}
                                reservedPlayer={detGame.reservedPlayer}
                                maxCapacity={detGame.maxCapacity}
                                guestsCount={detGame.guestsCount}
                                timeGame={!timeGame ? 'active' : 'inactive'}
                            />
                            <div className="w-full md:w-3/5 mx-auto flex-none md:flex space-x-8 py-10  px-1 md:px-10 border-2 bg-white shadow-lg rounded-xl">
                                <div className="w-full md:w-3/5 px-20 md:px-0 pb-10 md:pb-0 ">
                                    {detGame.description && (
                                        <div>
                                            <p className="text-center">{detGame.description}</p>
                                        </div>
                                    )}
                                    <div className="flex text-center justify-center content-center w-full items-center">
                                        <p className="absolute font-bold italic text-sm-blue-primary text-5xl ">{`${
                                            detGame.reservedGhost
                                                ? detGame.reservedGhost + detGame.reservedPlayer
                                                : detGame.reservedPlayer
                                        } de ${detGame.maxCapacity}`}</p>
                                        {detGame.reservation && detGame.reservation.start && (
                                            <div className="absolute flex text-center justify-center content-center w-2/5 sm:w-1/4 pt-20 items-center">
                                                <div className="w-full sm:w-2/5 ">
                                                    <Clock
                                                        deadline={detGame.reservation?.start}
                                                        alreadyJoined={detGame.alreadyJoined}
                                                        alreadyPaid={detGame.alreadyPaid}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <ChartDonught
                                            data={[
                                                detGame.reservedPlayer,
                                                detGame.maxCapacity,
                                                detGame.reservedGhost ? detGame.reservedGhost : 0,
                                            ]}
                                        />
                                    </div>
                                </div>

                                <div className="w-5/6  md:w-2/5 text-center items-center ">
                                    <PaymentLabels
                                        title="Fecha"
                                        icon="date"
                                        value={`${dateMatch.date}`}
                                        sport={sport}
                                    />
                                    <PaymentLabels
                                        title="Desde"
                                        icon="time"
                                        value={`${dateMatch.start} Hrs - ${dateMatch.end} Hrs`}
                                        sport={sport}
                                    />
                                    <PaymentLabels
                                        title="Lugar"
                                        icon="club"
                                        value={`${detGame.field?.club?.name}`}
                                        sport={sport}
                                    />
                                    <PaymentLabels
                                        title="Dirección"
                                        icon="location"
                                        value={`${detGame.field?.club?.address}`}
                                        sport={sport}
                                    />
                                    <PaymentLabels
                                        title="Cancha"
                                        icon="date"
                                        value={`${detGame.field?.name}`}
                                        sport={sport}
                                    />
                                    {/*detGame.field?.format && (
                                        <PaymentLabels
                                            title="Formato"
                                            icon="date"
                                            value={`${detGame.field?.format?.name}`}
                                        />
                                    )*/}
                                    <PaymentLabels
                                        title="Valor"
                                        icon="pay"
                                        value={`${formatPrice(detGame.pricePerPlayer, 0)} por persona`}
                                        sport={sport}
                                    />
                                </div>
                            </div>
                            <Copy />
                            {linkChat && <LinkChat linkChat={linkChat} />}
                            <div className="relative  z-0  w-full  ">
                                <div className="relative z-20 w-full md:w-1/2 mx-0 md:mx-auto flex md:space-x-10 lg:space-x-10  py-8  ">
                                    <div className="absolute top-2 left-0 w-full">
                                        <p className="text-center text-2xl font-bold  italic text-white">
                                            Nómina de Jugadores
                                        </p>
                                    </div>
                                    <div className="w-1/2  md:px-0 pb-10 md:pb-0 pt-6  rounded-lg">
                                        <p className="text-center text-2xl font-bold  italic text-white">
                                            {detGame.teamB?.name}
                                        </p>
                                        <Team
                                            capacity={detGame.maxCapacity}
                                            players={detGame.playersTeamB}
                                            sport={sport}
                                            colorTeam={'white'}
                                            color={`${
                                                detGame.teamB?.color === 'black'
                                                    ? ' bg-black '
                                                    : ' bg-white bg-opacity-30 '
                                            }`}
                                            text={`${
                                                detGame.teamB?.color === 'black' ? ' text-white ' : ' text-black '
                                            }`}
                                            contrast={`${
                                                detGame.teamB?.color === 'bg-black' ? 'bg-gray-300' : 'bg-white-300'
                                            }`}
                                        />
                                    </div>
                                    <div className="w-1/2  md:px-0 pb-10 md:pb-0 pt-6 rounded-lg">
                                        <p className="text-center text-2xl font-bold  italic text-white">
                                            {detGame.teamA?.name}
                                        </p>
                                        <Team
                                            capacity={detGame.maxCapacity}
                                            players={detGame.playersTeamA}
                                            sport={sport}
                                            colorTeam={'black'}
                                            color={`${
                                                detGame.teamA?.color === 'black'
                                                    ? ' bg-black  bg-opacity-25 '
                                                    : ' bg-white '
                                            }`}
                                            text={`${
                                                detGame.teamA?.color === 'black'
                                                    ? ' text-white '
                                                    : ' text-sm-blue-primary '
                                            }`}
                                            contrast={`${
                                                detGame.teamA?.color === 'bg-black' ? 'bg-black-300' : 'bg-black-300'
                                            }`}
                                        />
                                    </div>
                                </div>
                                <Image
                                    className="z-0"
                                    src={CoverImg}
                                    alt="Fondo"
                                    layout="fill"
                                    objectFit="cover"
                                    objectPosition="center"
                                />
                            </div>

                            {!timeGame && (
                                <div className="w-full md:w-2/5 mx-auto flex-none md:flex">
                                    <div className="flex text-center justify-center  content-center w-full pt-5 space-x-8">
                                        <CircleComponent
                                            size={'w-20 h-20'}
                                            bg={
                                                friends.current > 0
                                                    ? detGame.alreadyPaid && friends.current <= detGame.guestsCount
                                                        ? 'bg-gray-300 1'
                                                        : friends.current <= detGame.paidPlayer - 1
                                                        ? 'bg-gray-300 2'
                                                        : 'bg-sm-integrate 3'
                                                    : 'bg-gray-300 4'
                                            }
                                            value={'-'}
                                            border={false}
                                            text={' font-bold  text-4xl'}
                                            handlerAction={handlerDeduct}
                                        />
                                        <div
                                            className={`flex-col mt-4 text-center justify-center px-4 items-center text-5xl`}
                                        >
                                            <p className={``}>{friends.current}</p>
                                            {friends.current > 0 && (
                                                <p className={`text-xl pt-5 italic text-sm-blue-primary`}>
                                                    {auth && auth.user && auth.user.firstName
                                                        ? auth.user.firstName
                                                        : 'Tu'}{' '}
                                                    + {friends.current}
                                                </p>
                                            )}
                                        </div>
                                        <CircleComponent
                                            size={'w-20 h-20'}
                                            bg={
                                                detGame.reservedPlayer !== detGame.maxCapacity
                                                    ? 'bg-sm-integrate'
                                                    : friends.current !== 0 && friends.current + 1 < detGame.maxCapacity
                                                    ? 'bg-sm-integrate '
                                                    : 'bg-gray-300'
                                            }
                                            value={'+'}
                                            border={false}
                                            text={' font-bold  text-4xl'}
                                            handlerAction={
                                                (detGame.reservedPlayer !== detGame.maxCapacity ||
                                                    (friends.current !== 0 &&
                                                        friends.current + 1 < detGame.maxCapacity)) &&
                                                handlerAdd
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            {!timeGame && (
                                <div className="flex-col">
                                    <p className="text-center text-2xl italic text-sm-blue-primary pt-10 pb-2">
                                        Agregar amigos
                                    </p>
                                </div>
                            )}
                            {msj && (
                                <div className="flex-col">
                                    <p className="text-center text-2xl italic text-sm-integrate pt-10 pb-2">{msj}</p>
                                </div>
                            )}

                            {!timeGame && (
                                <div className="flex-col text-center pt-10 pb-5 space-x-8">
                                    <button
                                        className={`${
                                            detGame.reservedPlayer === detGame.maxCapacity ||
                                            (detGame.alreadyJoined && friends && friends.current === 0)
                                                ? friends.current !== 0 && friends.current + 1 < detGame.maxCapacity
                                                    ? ' bg-sm-integrate '
                                                    : detGame.guestsCount > 0
                                                    ? 'bg-sm-integrate '
                                                    : 'bg-gray-300 1'
                                                : friends.current === detGame.guestsCount && detGame.guestsCount !== 0
                                                ? 'bg-gray-300 2'
                                                : 'bg-sm-integrate '
                                        } w-1/2 md:w-1/4 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                        type="button"
                                        onClick={() => handlerNext()}
                                        disabled={
                                            detGame.reservedPlayer === detGame.maxCapacity ||
                                            (detGame.alreadyJoined && friends && friends.current === 0)
                                                ? friends.current !== 0 && friends.current + 1 < detGame.maxCapacity
                                                    ? false
                                                    : detGame.guestsCount > 0
                                                    ? false
                                                    : true
                                                : friends.current === detGame.guestsCount && detGame.guestsCount !== 0
                                                ? true
                                                : false
                                        }
                                    >
                                        {detGame.alreadyJoined ? 'Actualiza' : 'Voy'}
                                    </button>{' '}
                                </div>
                            )}
                            <Msj
                                alreadyJoined={detGame.alreadyJoined ? 'ready' : 'notReady'}
                                reservedPlayer={detGame.reservedPlayer}
                                maxCapacity={detGame.maxCapacity}
                                guestsCount={detGame.guestsCount}
                                timeGame={!timeGame ? 'active' : 'inactive'}
                            />
                            <div className="flex-col text-center pt-0 md:pt-10  space-x-8">
                                {detGame.alreadyJoined && cancelSuscription === 'inactive' && !timeGame && (
                                    <button
                                        className={`w-1/2 md:w-1/4 contact-button rounded-full text-white bg-sm-blue-primary uppercase py-4 font-extrabold`}
                                        type="button"
                                        onClick={() => handleCancel('active')}
                                        disabled={!detGame.alreadyJoined ? true : false}
                                    >
                                        Cancelar Reserva
                                    </button>
                                )}
                            </div>
                            <div className="block flex-col text-center py-5  space-x-8">
                                {role === 'ADMIN' && (
                                    <a
                                        className={`w-1/2 md:w-1/4 contact-button bg-sm-rent px-4 rounded-full text-white uppercase py-4 font-extrabold`}
                                        target="_blank"
                                        href={linkDashboard}
                                    >
                                        Ir al Dashboard de este partido
                                    </a>
                                )}
                            </div>
                            {cancelSuscription && cancelSuscription === 'active' && (
                                <div className="flex-col text-center pt-1 ">
                                    <p className="text-center text-2xl font-bold italic text-red-500 pt-4 pb-2">
                                        ¿Estás seguro que desea cancelar la suscripción a este partido?
                                    </p>
                                    <p className="text-center text-2xl font-bold italic text-red-500 pt-4 pb-4">
                                        No hay devolución de dinero en caso de cancelación.
                                    </p>
                                    <div className="flex space-x-8 text-center w-1/2 mx-auto justify-center items-center">
                                        <button
                                            className={`${'bg-green-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                            type="button"
                                            onClick={() => handleCancelSubcription()}
                                        >
                                            Si
                                        </button>
                                        <button
                                            className={`${'bg-red-500'} w-20 contact-button rounded-full text-white uppercase py-4 font-extrabold`}
                                            type="button"
                                            onClick={() => handleCancel('inactive')}
                                        >
                                            No
                                        </button>
                                    </div>
                                </div>
                            )}
                        </>
                    ) : (
                        detGame && (
                            <MsjSuccess className={' top-4 bg-sm-rent '} classSecondary={'md:w-1/4 lg:w-1/3'}>
                                <>
                                    <p className="pt-5 text-center text-2xl font-bold italic"> Juego cancelado</p>
                                    <p className="">_________________________</p>
                                    <p className="pt-2 px-6 text-center text-xl font-semibold italic">
                                        Tu suscripción a este juego fue cancelada
                                    </p>
                                </>
                            </MsjSuccess>
                        )
                    )}
                </LayoutInside>
            </>
        </Layout>
    );
};

export default Inscription;
